var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-actions",
            { staticClass: "card-bg-2 py-0 layout wrap", attrs: { wrap: "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "my-2 ml-0 mr-2",
                  attrs: { disabled: "", color: "info", id: "step18" },
                  on: { click: _vm.generateGraph },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v("insert_chart"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm.$t("Button.Generate_Graph"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "my-2 ml-0 mr-2",
                  on: {
                    click: function ($event) {
                      return _vm.generateTabular()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("storage")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm.$t("Button.View_As_Tabular"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "my-2 ml-0",
                  attrs: { loading: _vm.loadingDownloadData },
                  on: {
                    click: function ($event) {
                      return _vm.downloadData()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("save_alt")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm.$t("Button.DownloadExcelReport"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _vm.mainInterfaceIsLoading
            ? _c("v-progress-linear", {
                attrs: { indeterminate: _vm.mainInterfaceIsLoading },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "card-bg-2", attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { staticClass: "divider-right", attrs: { xs12: "", md5: "" } },
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Date Range"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "py-0" },
                    [
                      _c("DateRange", {
                        attrs: {
                          rounded: "",
                          solo: "",
                          minDate: _vm.minDate,
                          maxDate: _vm.maxDate,
                          selectedRange: _vm.selectedRange,
                          availableDateRange: {
                            start: _vm.minDate,
                            end: _vm.maxDate,
                          },
                          "min-max-placeholder": _vm.formats.prettyDateFormat,
                          shortcutPrefix: "Show",
                          shortcuts: _vm.shortcuts,
                          "no-arrows": "",
                          data: _vm.availableData,
                        },
                        on: {
                          "update:selectedRange": function ($event) {
                            _vm.selectedRange = $event
                          },
                          "update:selected-range": function ($event) {
                            _vm.selectedRange = $event
                          },
                        },
                        model: {
                          value: _vm.dates,
                          callback: function ($$v) {
                            _vm.dates = $$v
                          },
                          expression: "dates",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Aggregation Options"),
                  ]),
                  _vm._v(" "),
                  _c("v-card-text", { staticClass: "py-0 pb-2" }, [
                    _c("span", [
                      _vm._v(
                        "Numeric fields with multiple samples per date can be aggregated using various schemes."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.aggregationHeaders,
                      items: _vm.selectedAggregationVariables,
                      "item-key": _vm.ID_KEY,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function (props) {
                          return [
                            _c("tr", [
                              _c("td", [_vm._v(_vm._s(props.item.Variable))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.dataAggregationTypeValues,
                                      multiple: "",
                                      label: "Aggregations",
                                      chips: "",
                                      box: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: props.item.Aggregations,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          props.item,
                                          "Aggregations",
                                          $$v
                                        )
                                      },
                                      expression: "props.item.Aggregations",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "no-data",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "pa-4 text-xs-center" },
                              [
                                _c("v-icon", { attrs: { color: "info" } }, [
                                  _vm._v("info"),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n              To use aggregation, please select numeric data with multiple samples per date\n            "
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("v-divider"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "divider-left", attrs: { xs12: "", md7: "" } },
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "headline pb-0",
                          staticStyle: {
                            "align-items": "baseline",
                            display: "flex",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Plot Survey Variables\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-text-field", {
                        staticClass: "rounded font-weight-regular",
                        attrs: {
                          "prepend-inner-icon": "search",
                          "hide-details": "",
                          clearable: "",
                          solo: "",
                          placeholder: "Search plot surveys",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "py-0 px-0" },
                    [
                      _c(
                        "v-item-group",
                        {
                          attrs: {
                            mandatory: "",
                            "active-class": "white--text",
                          },
                          model: {
                            value: _vm.filterToggle,
                            callback: function ($$v) {
                              _vm.filterToggle = $$v
                            },
                            expression: "filterToggle",
                          },
                        },
                        [
                          _c(
                            "v-subheader",
                            {
                              staticStyle: {
                                display: "inline",
                                cursor: "default",
                              },
                            },
                            [_vm._v("Show:")]
                          ),
                          _vm._v(" "),
                          _c("v-item", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ active, toggle }) {
                                  return _c(
                                    "v-chip",
                                    {
                                      staticClass: "chipFilter",
                                      attrs: {
                                        small: "",
                                        color: active ? "primary" : "default",
                                        selected: active,
                                      },
                                      on: { click: toggle },
                                    },
                                    [_vm._v("All")]
                                  )
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("v-item", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ active, toggle }) {
                                  return _c(
                                    "v-chip",
                                    {
                                      staticClass: "chipFilter",
                                      attrs: {
                                        small: "",
                                        color: active ? "primary" : "default",
                                        selected: active,
                                      },
                                      on: { click: toggle },
                                    },
                                    [
                                      _c(
                                        "v-avatar",
                                        {
                                          staticClass: "chip-log-count",
                                          staticStyle: {
                                            "border-radius": "0px",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.selected.length))]
                                      ),
                                      _vm._v(
                                        "\n                Selected\n              "
                                      ),
                                    ],
                                    1
                                  )
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("v-data-table", {
                        attrs: {
                          search: _vm.search,
                          headers: _vm.headers,
                          "select-all": "",
                          pagination: _vm.pagination,
                          items: _vm.items,
                          "item-key": _vm.ID_KEY,
                          loading: _vm.surveyVariables.isLoading,
                        },
                        on: {
                          "update:pagination": function ($event) {
                            _vm.pagination = $event
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "headers",
                            fn: function (props) {
                              return [
                                _c(
                                  "tr",
                                  [
                                    _c(
                                      "th",
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            color: "primary",
                                            "input-value": props.all,
                                            indeterminate: props.indeterminate,
                                            primary: "",
                                            "hide-details": "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.toggleAll()
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._l(props.headers, function (header) {
                                      return _c(
                                        "th",
                                        {
                                          key: header.text,
                                          class: [
                                            "column sortable",
                                            _vm.pagination.descending
                                              ? "desc"
                                              : "asc",
                                            header.value ===
                                            _vm.pagination.sortBy
                                              ? "active"
                                              : "",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.changeSort(
                                                header.value
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("arrow_upward")]
                                          ),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(header.text) +
                                              "\n                "
                                          ),
                                        ],
                                        1
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ]
                            },
                          },
                          {
                            key: "items",
                            fn: function (props) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    staticClass: "clickable",
                                    attrs: { active: props.selected },
                                    on: {
                                      click: function ($event) {
                                        props.selected = !props.selected
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "td",
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            color: "info",
                                            "hide-details": "",
                                            "input-value": props.selected,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(props.item.Variable)),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(props.item.DataType)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatDateTime(
                                                props.item.FirstRecordDate,
                                                {
                                                  format:
                                                    _vm.formats
                                                      .prettyDateTimeFormat,
                                                }
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatDateTime(
                                                props.item.LastRecordDate,
                                                {
                                                  format:
                                                    _vm.formats
                                                      .prettyDateTimeFormat,
                                                }
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(props.item.NumberOfRecords)
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.selected,
                          callback: function ($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("PlotSurveyQueryResultTabularView", {
        attrs: {
          data: _vm.queryResults.data,
          aggregateColumns: _vm.aggregateColumns,
          startDate: _vm.dates.start,
          endDate: _vm.dates.end,
          hasQueriedAggregateData: _vm.hasQueriedAggregateData,
          showAllValues: _vm.showAllValues,
          loading: _vm.queryResults.isLoading,
        },
        on: {
          "update:showAllValues": function ($event) {
            _vm.showAllValues = $event
          },
          "update:show-all-values": function ($event) {
            _vm.showAllValues = $event
          },
          refresh: _vm.executeSurveyQuery,
        },
        model: {
          value: _vm.showTabularView,
          callback: function ($$v) {
            _vm.showTabularView = $$v
          },
          expression: "showTabularView",
        },
      }),
      _vm._v(" "),
      _c("FileDownloadModal", {
        attrs: {
          title: "Report Result Download",
          fileResults: _vm.fileResults,
        },
        model: {
          value: _vm.showFileResultDownload,
          callback: function ($$v) {
            _vm.showFileResultDownload = $$v
          },
          expression: "showFileResultDownload",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }